'use strict';

var util = require('./util'),
	bonusProductsView = require('./bonus-products-view'),
	quantity = require('./pages/product/quantity'),
	linchpin = require('int_googletagmanager/linchpin/quantity'),
	subscriptions = require('int_googletagmanager/linchpin/subscription');

var timer = {
	id: null,
	clear: function () {
		if (this.id) {
			window.clearTimeout(this.id);
			delete this.id;
		}
	},
	start: function (duration, callback) {
		this.id = setTimeout(callback, duration);
	}
};

var minicart = {
	init: function () {
		this.$el = $('#mini-cart');
		this.updateQty();
		this.$el.on('keypress', '.input-group input', function (event) {
			if (event.which === 13) {
				event.preventDefault();
				$('button[name$="_updateProduct"]').trigger('click');
			} else {
				var $qtyControls = $(this).closest('.mini-cart-product-update');
				var $qtyInput = $qtyControls.find('input.input-text');
				var $updateLink = $qtyControls.find('.update-link button');
				if ($qtyInput.val() !== $qtyInput.attr('value')) {
					$updateLink.prop('disabled', false);
				} else {
					$updateLink.prop('disabled', true);
				}
			}
		});
		this.$el.on('click', 'button[name$="_deleteProduct"]', function (event) {
			minicart.removeItem(event);
		});
		this.$el.on('click', 'button[name$="_updateProduct"]', function (event) {
			minicart.updateItem(event);
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.updateQuantityEvent();
			}
		});
		this.$el.on('click', 'button[name$="_deleteGiftCertificate"]', function (event) {
			minicart.removeGiftCert(event);
		});
		quantity.init();

		$('.mini-cart-link-checkout').on('click', function (event) {
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.shoppingBagMiniCheckout(event);
			}
		});
	},
	updateQty: function () {
		var qty = this.$el.find('.mini-cart-wrapper').data('qty'),
			qtyLength = $.trim(qty).length,
			minicartClass = this.$el[0].className,
			regex = /n-+\d{1,1}-items/;
		//revoke class by removing 'n-' every time qty changed
		this.$el[0].className = minicartClass.replace(regex, '');
		if (qty) {
			//update class
			this.$el.addClass('n-' + qtyLength + '-items');
			$('.minicart-total-qty').html(qty);
		} else {
			$('.minicart-total-qty').html('');
		}
	},

	triggerDropDown: function () {
		this.$el.addClass('hover');
		util.renderClosePadForTouch(false, 'addToMinCart');
		this.$el.find('.drop-down-options').one('touchstart mouseenter', function (e) {
			if (e.target && e.target.className.indexOf('mini-cart-link-checkout') !== -1) {
				e.preventDefault();
				e.stopPropagation();
				$(e.target).addClass('hover');
				setTimeout(function () {
					window.location = $(e.target).attr('href');
				}, 20);
			} else {
				$('.uiLayerIndicator').remove();
				util.renderClosePadForTouch(false, 'dropDown');
				timer.clear();
				e.preventDefault();
			}
		});
	},
	/**
	 * @function
	 * @description Shows the given content in the mini cart
	 * @param {String} A HTML string with the content which will be shown
	 */
	show: function (html) {
		this.$el.find('.drop-down-options').html(html);
		util.scrollBrowser(0);
		this.updateQty();
		this.slide();
		bonusProductsView.loadBonusOption();
		quantity.init();

		if (SitePreferences.GTM_ENABLED) {
			setTimeout(subscriptions.getSubscriptionAddToBagData, 3000);
		}
	},
	/**
	 * @function
	 * @description Slides down and show the contents of the mini cart
	 */
	slide: function () {
		timer.clear();
		this.triggerDropDown();
		timer.start(6000, this.close);
	},
	/**
	 * @function
	 * @description Closes the mini cart with given delay
	 */
	close: function () {
		timer.clear();
		$('#mini-cart').removeClass('hover');
		$('.uiLayerIndicator').remove();
	},

	/**
	 * @function
	 * @description Removes a product line item from the cart
	 */
	removeItem: function (event) {
		event.preventDefault();
		var $form = $('#minicart-items-form'),
			name = '&' + event.currentTarget.name + '=1',
			pid = $(event.target).closest('.mini-cart-product-remove button').data('pid');
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.removeFromBag(event, pid);
			}
		$.ajax({
			url: Urls.removeMiniCartProduct,
			data: $form.serialize() + name,
			type: 'POST'
		})
		.done(function (response) {
			minicart.show(response);
		});
	},
	/**
	 * @function
	 * @description Updates the quantity for a single product line item
	 */
	updateItem: function (event) {
		event.preventDefault();
		var $form = $('#minicart-items-form'),
		name = '&' + event.currentTarget.name + '=1';
		$.ajax({
			url: Urls.updateMiniCartProduct,
			data: $form.serialize() + name,
			type: 'POST'
		})
		.done(function (response) {
			minicart.show(response);
		});
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.shoppingBagMiniUpdate(event);
		}
	},
	/**
	 * @function
	 * @description Removes a gift certificate line item from the cart
	 */
	removeGiftCert: function (event) {
		event.preventDefault();
		var $form = $('#minicart-items-form'),
			name = '&' + event.currentTarget.name + '=1';
		$.ajax({
			url: Urls.removeMiniCartGiftCert,
			data: $form.serialize() + name,
			type: 'POST'
		})
		.done(function (response) {
			minicart.show(response);
		});
	}
};

module.exports = minicart;
